import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="py-32 bg-emerald-950 relative overflow-hidden" data-id="element-128">
      {/* Background Accents */}
      <div className="absolute inset-0 bg-diagonal-stripes opacity-30 pointer-events-none" data-id="element-129" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-130" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-131">
        <FadeIn data-id="element-132">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-133">
            Obtén el sistema completo <br className="hidden md:block" data-id="element-134" />
            <span className="text-gradient-gold" data-id="element-135">
              Rutina Bio-Fitness: El Método ERBF
            </span>{' '}
            hoy mismo.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-136">
          <div className="my-12" data-id="element-137">
            <p className="text-emerald-200/80 font-heading uppercase tracking-widest text-sm mb-4" data-id="element-138">
              Precio Especial de Lanzamiento
            </p>
            <div className="flex flex-col items-center gap-3" data-id="element-139">
              <div className="flex items-center justify-center gap-4" data-id="element-140">
                <span className="text-3xl text-emerald-500/50 line-through font-bold" data-id="element-141">
                  $65
                </span>
                <span className="text-7xl md:text-8xl font-bold text-white drop-shadow-[0_0_30px_rgba(212,175,55,0.3)]" data-id="element-142">
                  $7.90
                </span>
              </div>
              <span className="inline-block bg-gold-500/20 text-gold-400 font-heading font-bold text-sm md:text-base px-4 py-1.5 rounded-full border border-gold-500/30 tracking-wide" data-id="element-143">
                88% DE DESCUENTO
              </span>
            </div>
            <p className="text-emerald-100/60 font-body mt-4" data-id="element-144">
              (Un solo pago. Acceso inmediato).
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-145">
          <CTAButton href="https://www.novantumnexus.com/cart/53955401646355:1" className="w-full md:w-auto md:px-16 md:py-6 text-xl md:text-3xl mb-8" data-id="element-146">
            ¡OBTENER MI PLAN BIO-FITNESS!
          </CTAButton>

          <div className="flex items-center justify-center gap-2 text-emerald-200/70 font-body text-sm md:text-base" data-id="element-147">
            <ShieldCheckIcon className="w-5 h-5 text-gold-400" data-id="element-148" />
            <span data-id="element-149">
              Compra segura. Entrega inmediata en formato digital PDF.
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}